import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Card, CardContent, Button } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useAuth } from '../context/AuthContext';

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <Container maxWidth="sm">
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Card>
          <CardContent>
            <CancelIcon sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
            <Typography variant="h4" gutterBottom>
              Payment Cancelled
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Your payment was cancelled. No charges were made to your account.
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              You can return to the pricing page to try again whenever you're ready.
            </Typography>
            <Box sx={{ mt: 3 }}>
              <Button
                variant="contained"
                onClick={() => navigate(user ? '/pricing?mode=upgrade' : '/pricing')}
              >
                Back to Pricing
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default PaymentCancel;

